import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from 'react';

export interface OrderDetailContextDef {
  showHistoryDialog: boolean;
  setShowHistoryDialog?: Dispatch<SetStateAction<boolean>>;
}

const defaultValues: OrderDetailContextDef = {
  showHistoryDialog: false,
};

const OrderDetailContext = createContext<OrderDetailContextDef>(defaultValues);

const useStatesAndActions = (): OrderDetailContextDef => {
  const [showHistoryDialog, setShowHistoryDialog] = useState<boolean>(false);

  return {
    showHistoryDialog,
    setShowHistoryDialog,
  };
};

export const useOrderDetailContext = () => {
  const context = useContext(OrderDetailContext);
  if (!context) throw new Error('component is not inside OrderDetailContext');
  return context;
};

export const OrderDetailContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <OrderDetailContext.Provider value={useStatesAndActions()}>
    {children}
  </OrderDetailContext.Provider>
);
